import http from "./axios";

export default {
  async getPathologies() {
    try {
      const { data:pathologies } = await http.get(`/api/pathologies`);
      return pathologies.data;
    } catch (error) {
      throw error.response || error;
    }
  },
};
